// extracted by mini-css-extract-plugin
module.exports = {"image":"EX0opXW_-ULUUehNoXHP5"};